import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

const state = {
  cartRewardItem: {},
  cartRewardItems: []
}

const mutations = {
  REQUEST (state) {
    state.status = 'loading'
  },
  SUCCESS (state) {
    state.status = 'success'
  },
  ERROR (state, error) {
    state.status = 'error'
  },
  SET_CART_REWARD_ITEMS (state, items) {
    state.cartRewardItems = items
  },
  REMOVE_CART_REWARD_ITEM (state, item) {
    state.cartRewardItems = state.cartRewardItems.filter(cartItem => {
      return cartItem._id !== item._id
    })
  }
}

const actions = {
  adminUpdateCartRewardItem ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/cartRewardItem/update`, payload)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  clientAddCartRewardItem ({ commit }, cartRewardItem) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/cartRewardItem/create`, cartRewardItem)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  clientGetCartRewardItems ({ commit }, userLoyaltyProgramId) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/client/cartRewardItem/list/${userLoyaltyProgramId}`)
        .then(response => {
          commit('SUCCESS')
          commit('SET_CART_REWARD_ITEMS', response.data.cart)
          resolve(response.data.cart)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  clientRemoveCartRewardItem ({ commit }, cartRewardItem) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/cartRewardItem/${cartRewardItem._id}/delete`, cartRewardItem)
        .then(response => {
          commit('SUCCESS')
          commit('REMOVE_CART_REWARD_ITEM', cartRewardItem)
          resolve(response.data.item)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  clientSubmitCart ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/cartRewardItem/submit`, payload)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.item)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  clientEmptyCart ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/cartRewardItem/empty`, payload)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.item)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  }
}

const getters = {
  unsubmittedItems: state => {
    return state.cartRewardItems.filter(item => !item.submitted)
  },
  submittedItemsNotApproved: state => {
    return state.cartRewardItems.filter(item => item.submitted && !item.shipped)
  },
  approvedItems: state => {
    return state.cartRewardItems.filter(item => item.submitted && item.shipped)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
